/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable import/extensions, import/no-unresolved */

import fileDownload from 'js-file-download'
import { HttpStatusCode } from '../../protocols/http/http-client'
import { UnauthorizedError } from '../../../domain/errors/unauthorized-error'
import { AccessDeniedError } from '../../../domain/errors/access-denied-error'
import { UnexpectedError } from '../../../domain/errors/unexpected-error'

export class RemoteProgramRules {
  url: string

  httpClient: any

  constructor(url: string, httpClient: any) {
    this.url = url
    this.httpClient = httpClient
  }

  async create(data: any, params?: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('/{YEAR}', ''),
      method: 'post',
      params,
      data,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.badRequest:
        const msg = httpResponse.body.length > 0 ? httpResponse.body[0].msgUsuario : 'Erro na requisição'
        throw new Error(msg)
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.ok: return httpResponse.body
      case HttpStatusCode.noContent: return undefined
      default: throw new UnexpectedError()
    }
  }

  async load(params?: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async download(params?: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      params,
      headers: {
        Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
      },
      responseType: 'arraybuffer',
    })

    const tempData = httpResponse.body.length > 0 ? httpResponse.body[0].msgUsuario : 'Erro na requisição'

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.badRequest: throw new Error(tempData)
      case HttpStatusCode.serverError: throw new Error(tempData)
      case HttpStatusCode.ok:
        fileDownload(httpResponse.body, `ACEITE_LIGA_${params?.ano}.xlsx`)
        return httpResponse.body
      default: throw new UnexpectedError()
    }
  }
}
